import React, { useEffect, useState } from "react";
import UserPageLayout from "../../../../components/UserPageLayout";
import { Link, useParams, useNavigate } from "react-router-dom";
import { EAData } from "../../../../network/api/EAData";
import { useAppContext } from "../../../../../../context/AppContext";
import Toast from "../../../../../../components/Toast";
import Pagination from "../../../../../../components/Pagination";
import EditEAForm from "../../components/EditEAForm";
import { encodeId, decodeId } from "../../../../../../utils/hash";
import EADetailsCard from "../../components/EADetailsCard";
import CardLoader from "../../../../../../components/CardLoader";
import { SymbolsData } from "../../../../network/api/SymbolsData";
import { SymbolData } from "../../../../network/api/SymbolData";
import { LicencesData } from "../../../../network/api/LicencesData";
import { highlightText } from "../../../../../../utils/highlight";
import ButtonLoader from "../../../../../../components/ButtonLoader";
import TradeCard from "../../components/TradeCard";

export default function ExpertAdvisor() {
  const { setPageTitle, appData, setPageUserID } = useAppContext();
  const { id: eaID } = useParams();
  const navigate = useNavigate();

  const eaId = decodeId(eaID);

  const [pageLoading, setPageLoading] = useState(false);
  const [expert, setExpert] = useState(null);


  const [symbolsLoading, setSymbolsLoading] = useState(false);
  const [symbolsErrorMessage, setSymbolsErrorMessage] = useState(null);
  const [symbolReload, setSymbolReload] = useState(false);
  const [symbols, setSymbols] = useState([]);

  const [tradeMode, setTradeMode] = useState(false);
  const [selectedSymbol, setSelectedSymbol] = useState(null);



  const [toastConfig, setToastConfig] = useState({
    message: "",
    type: "primary",
  });
  const [symbolInput, setSymbolInput] = useState("");

  const [pageProps, setPageProps] = useState({
    page: 1,
    totalPages: 1,
    totalEntries: 0,
    entryLimit: 10,
    visiblePages: []
  });

  const [pageFilters, setPageFilters] = useState({
    page: null,
    user: null,
    key: null,
    email: null,
    status: null,
    type: null,
  });




  const [licencesLoading, setLicencesLoading] = useState(false);
  const [licencesErrorMessage, setLicencesErrorMessage] = useState(null);
  const [licenceReload, setLicenceReload] = useState(false);
  const [licences, setLicences] = useState([]);

  const [confirmDelete, setConfirmDelete] = useState(false);

  const [activeFilters, setActiveFilters] = useState(["all"]);
  const handleFilters = (e) => {
    e.preventDefault();
    const { name } = e.target;

    const statusOptions = ["active", "expired"];
    const typeOptions = ["normal", "subscription"];

    if (name === "all") {
      setActiveFilters(["all"]);
      setPageFilters((prev) => ({
        ...prev,
        page: null,
        status: null,
        type: null,
      }));
      return;
    }

    setActiveFilters((prev) => {
      let updated = [...prev];
      const isSelected = updated.includes(name);

      if (statusOptions.includes(name)) {
        updated = updated.filter((item) => !statusOptions.includes(item));
        if (!isSelected) updated.push(name);
      } else if (typeOptions.includes(name)) {
        updated = updated.filter((item) => !typeOptions.includes(item));
        if (!isSelected) updated.push(name);
      } else {
        if (isSelected) {
          updated = updated.filter((item) => item !== name);
        } else {
          updated = updated.filter((item) => item !== "all");
          updated.push(name);
        }
      }

      const status = updated.includes("active")
        ? "Active"
        : updated.includes("expired")
          ? "Expired"
          : null;

      const type = updated.includes("normal")
        ? "Normal"
        : updated.includes("subscription")
          ? "Subscription"
          : null;

      setPageFilters((prevFilters) => ({
        ...prevFilters,
        page: null,
        status,
        type,
      }));

      return updated;
    });
  };


  const handlePageChange = (page) => {
    if (page >= 1 && page <= pageProps.totalPages) {
      setPageProps((prev) => ({
        ...prev,
        page: page,
      }));
    }
    setPageFilters((prev) => ({
      ...prev,
      page,
    }));
  };

  const [searchValue, setSetchValue] = useState(null);
  const handleSerchChange = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setSetchValue(value);

    if (value.length >= 3) {
      setPageFilters((prev) => ({
        ...prev,
        page: null,
        user: value,
        key: value,
        email: value
      }));

    }

    if (value.length === 0) {
      setPageFilters((prev) => ({
        ...prev,
        page: null,
        user: null,
        key: null,
        email: null
      }));
    }

  }

  const handleDeleteEA = () => {
    setPageLoading(true);
    setTimeout(async () => {
      try {
        const response = await EAData({ method: "DELETE", id: expert?.id });
        if (response.status === "success") {
          setToastConfig({ visible: true, message: `${response.message} Deleting EA ${expert?.id} `, type: (response.status) === "error" ? "danger" : response.status });
          setTimeout(() => {
            navigate(-1);
          }, 500);

        } else {
          setToastConfig({ visible: true, message: `${response.message}  Deleting EA ${expert?.id}`, type: (response.status) === "error" ? "danger" : response.status });

        }
      } catch (err) {
        setToastConfig({ visible: true, message: "Delete failed", type: "danger" });
      } finally {
        setPageLoading(false);
      }

    }, 500);
  };

  const handleAddSymbol = (e) => {
    e.preventDefault();
    const symbolInput = e.target.symbol.value;
    if (!symbolInput.trim()) return;
    handleSymbolData(null, { ea: expert?.id, name: symbolInput.trim() });
    setSymbolInput("");
  };

  const handleSymbolData = async (symbol = null, formData = null) => {

    setSymbolsLoading(true);
    try {

      const method = formData && !symbol ? "POST" : "DELETE";
      const response = await SymbolData({ method: method, id: symbol?.id, formData: formData });
      if (response.status === "success") {
        setToastConfig({ visible: true, message: `${response.message} ${method === "POST" ? "ADD" : method} Symbol ${symbol?.name || formData?.name} `, type: (response.status) === "error" ? "danger" : response.status });
        setSymbolReload(!symbolReload);
      } else {
        setToastConfig({ visible: true, message: `${response.message}  ${method === "POST" ? "ADD" : method} Symbol ${symbol?.name || formData?.name}`, type: (response.status) === "error" ? "danger" : response.status });
        setSymbolsLoading(false);
      }
    } catch (err) {
      setToastConfig({ visible: true, message: "Delete failed", type: "danger" });
      setSymbolsLoading(false);
    }

  };





  useEffect(() => {
    if (!expert) return
    setSymbolsLoading(true);
    const fetchSymbols = async () => {
      try {
        const response = await SymbolsData({ eaId: eaId });
        if (response.status === "success") {
          setSymbols(response.data.reverse());
        } else {
          setSymbolsErrorMessage({ code: response.code, message: response.message });
        }
      } catch (err) {
        setSymbolsErrorMessage({ code: 500, message: "Failed to fetch symbols" });
      } finally {
        setSymbolsLoading(false);
      }
    }

    fetchSymbols();
  }, [eaId, expert, symbolReload]);


  useEffect(() => {
    const fetchLicences = async () => {
      setLicencesLoading(true);
      setLicencesErrorMessage(null);
      try {
        const response = await LicencesData({ pageFilters: pageFilters, appName: appData?.name, eaId: expert?.id });

        if (response.status === "success") {
          setLicences(response.data.data);

          setPageProps({
            page: response.data.page,
            totalPages: response.data.total_pages,
            totalEntries: response.data.total_records,
            entryLimit: response.data.limit,
            visiblePages: response.data.visible_pages,
          })
        } else {
          setLicencesErrorMessage({ code: response.code, message: response.message });
        }
      } catch (err) {
        setLicencesErrorMessage({ code: 500, message: "Failed to fetch symbols" });
      } finally {
        setLicencesLoading(false);
      }
    }

    if (expert) {
      setPageUserID(expert?.owner);
      fetchLicences();
    }
  }, [pageFilters, appData, expert, setPageUserID]);


  useEffect(() => {
    setPageTitle("EA Details");
  }, [setPageTitle]);

  return (
    <UserPageLayout>
      <Toast message={toastConfig.message}
        type={toastConfig.type}
        visible={toastConfig.visible}
        setVisible={(visible) => setToastConfig({ ...toastConfig, visible })}
      />
      <div className="content-body">
        <div className="container-fluid">
          <div className="row page-titles">
            <ol className="breadcrumb">
              <li className="breadcrumb-item  "><Link to={`/users/${encodeId(expert?.owner)}/eas`}>eas</Link></li>
              <li className="breadcrumb-item  active"><span>EA Details</span></li>

              <div className="dropdown ms-auto">
                <div className="btn sharp  btn-primary" data-bs-toggle="dropdown">
                  <i className="fas fa-gear"></i>
                </div>
                <ul className="dropdown-menu dropdown-menu-right">
                  <li className="dropdown-item">
                    <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="modal" data-bs-target="#editEAModal" className="dropdown-link">
                      <i className="fas fa-edit text-primary me-2"></i> Edit EA Details
                    </a>
                  </li>
                  <li className="dropdown-item">
                    <Link to={`/eas/${encodeId(expert?.id)}/link`}  className="dropdown-link">
                      <i className="fas fa-link text-primary me-2"></i> EA Link
                    </Link>
                  </li>
                  <li className="dropdown-item">
                    <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="modal" data-bs-target="#deleteModalCenter" className="dropdown-link">
                      <i className="fas fa-trash text-danger me-2"></i> Delete EA
                    </a>
                  </li>
                </ul>
              </div>
            </ol>
          </div>

          <>
            <div className="row">

              <div className="col-lg-8 col-md-12 col-sm-12">
                <EADetailsCard eaId={eaId} setExpert={setExpert} expert={expert} showImage={true} showEACode={true} />
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12">
                {!tradeMode ?
                  (<div className="card bg-primary border-0 pb-0">
                    {(symbolsLoading || symbolsErrorMessage) && (<CardLoader errorMessage={symbolsErrorMessage} onRetry={() => { setSymbolReload(!symbolReload); }} />)}
                    <div className="card-header border-0 pb-0 d-flex justify-content-between align-items-start">

                      <div className="d-flex w-100">
                        <div>
                          <h4 className="text-white mb-2">SYMBOLS</h4>
                          <small className="text-white d-block m-0 me-4">
                            Make sure you add the symbol exactly as it appears in your broker.
                          </small>
                        </div>
                        <div className="ms-auto" style={{ maxWidth: "500px" }} onSubmit={handleAddSymbol}>
                          <form className="input-group input-group-sm search-area mb-xxl-0 mb-2">
                            <input
                              name="symbol"
                              type="text"
                              className="form-control"
                              placeholder="GBPUSD"
                              required={true}
                              value={symbolInput}
                              onChange={(e) => setSymbolInput(e.target.value)}
                            />
                            <button
                              type="submit"
                              className="btn input-group-text text-sm"
                            >
                              <i className="fas fa-plus fa-sm"></i>
                            </button>
                          </form>
                        </div>
                      </div>

                    </div>
                    <div className="card-body p-0">
                      <div className="position-relative">
                        {symbolsLoading && (
                          <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-75" style={{ zIndex: 5 }}>
                            <div className="spinner-border text-light" role="status"></div>
                          </div>
                        )}
                        <div id="DZ_W_Todo4" className="widget-media dz-scroll my-4 px-4 height370">
                          {symbols.length > 0 ?
                            <ul className="timeline">
                              {symbols.map((symbol, index) => (
                                <li key={index}>
                                  <div className="timeline-panel d-flex justify-content-between align-items-center">

                                    <a href="/" onClick={(e) => {
                                      e.preventDefault();
                                      setSelectedSymbol(symbol);
                                      setTradeMode(true);
                                      const sound = new Audio('/assets/sounds/connected.wav');
                                      sound.play();
                                    }} className="media-body">
                                      <h5 className="mb-0 text-white">{symbol.name}</h5>
                                      <small className="text-muted">{new Date(symbol?.created).toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' })}</small>
                                    </a>
                                    <div className="dropdown">
                                      <button type="button" className="btn  btn-light light sharp" data-bs-toggle="dropdown">
                                        <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1">
                                          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <rect x="0" y="0" width="24" height="24" />
                                            <circle fill="#000000" cx="5" cy="12" r="2" />
                                            <circle fill="#000000" cx="12" cy="12" r="2" />
                                            <circle fill="#000000" cx="19" cy="12" r="2" />
                                          </g>
                                        </svg>
                                      </button>
                                      <div className="dropdown-menu dropdown-menu-end">
                                        <button onClick={() => handleSymbolData(symbol)} className="dropdown-item" href="#">Delete</button>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              ))}

                            </ul> :
                            <div className="d-flex flex-column justify-content-center align-items-center py-5">
                              <i className="fa fa-folder-open text-light mb-3" style={{ fontSize: "4rem" }}></i>
                              <h3 className="text-light">No Symbol Found</h3>
                            </div>}

                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        {symbols.length > 0 && (
                          <div
                            className="scroll-indicator text-center rounded-circle"
                            style={{
                              position: "absolute",
                              bottom: 15,
                              left: "50%",
                              transform: "translateX(-50%)",
                              zIndex: 10,
                              pointerEvents: "none",
                              width: "60px",
                              height: "60px",
                              backgroundColor: "rgba(255,255,255,0.15)",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              borderRadius: "50%",
                              boxShadow: "0 0 8px rgba(0,0,0,0.4)"
                            }}
                          >
                            <i className="fas fa-chevron-down text-white" style={{ fontSize: "1.25rem" }}></i>
                          </div>
                        )}
                      </div>
                    </div>

                  </div>)
                  : (<TradeCard setTradeMode={setTradeMode} selectedSymbol={selectedSymbol} expert={expert} setToastConfig={setToastConfig} />)
                }
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12 col-lg-12 col-sm-12">
                <h2 className="title my-3">Licenses</h2>
                <div className="d-flex mb-4 justify-content-between align-items-center flex-wrap">

                  <div className="card-tabs mt-3 mt-sm-0 mb-xxl-0 mb-4">

                    <ul className="nav nav-tabs" role="tablist">
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeFilters.includes("all") ? "active" : ""} `}
                          onClick={handleFilters}
                          name="all"
                        >
                          All Keys ({pageProps.totalEntries})
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeFilters.includes("active") ? "active" : ""}`}
                          onClick={handleFilters}
                          name="active"
                        >
                          Active
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeFilters.includes("expired") ? "active" : ""}`}
                          onClick={handleFilters}
                          name="expired"
                        >
                          Expired
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeFilters.includes("normal") ? "active" : ""}`}
                          onClick={handleFilters}
                          name="normal"
                        >
                          Normal
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeFilters.includes("subscription") ? "active" : ""}`}
                          onClick={handleFilters}
                          name="subscription"
                        >
                          Subscription
                        </button>
                      </li>


                    </ul>
                  </div>
                  <div className="table-search">
                    <div className="input-group search-area mb-xxl-0 mb-4">
                      <input type="text" className="form-control" placeholder="Search here" onChange={handleSerchChange} />
                      <span className="input-group-text"><i className="flaticon-381-search-2"></i></span>
                    </div>
                  </div>
                  <Link to={`/eas/${encodeId(expert?.id)}/license/create`} className="btn btn-primary mb-xxl-0 mb-4 radius-btn" ><i className="fa-solid fa-plus me-2"></i>Generate License Key</Link>
                </div>

                <div className="">
                  <div id="guestTable-all-1_wrapper" className="dataTables_wrapper no-footer ">
                    <div className="card custom-card">

                      {(licencesLoading || licencesErrorMessage) && (<CardLoader errorMessage={licencesErrorMessage} onRetry={() => { setLicenceReload(!licenceReload); }} />)}
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title">Licences</h4>
                        <Link to={`/eas/${encodeId(expert?.id)}/license/create`} className="btn btn-primary btn-sm" title="Add Licence" >
                          <i className="fa fa-plus text-white" />
                        </Link>
                      </div>
                      <div className="card-body">


                        <div className="table-responsive recentOrderTable">
                          <table className="table verticle-middle table-responsive-md">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">User</th>
                                <th scope="col">Email</th>
                                <th scope="col">License Key</th>
                                <th scope="col">Status</th>
                                <th scope="col">Created</th>
                                <th scope="col">Type</th>
                                <th scope="col">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {licences.length > 0 ? (
                                licences.map((item, index) => (
                                  <tr key={index}>
                                    <td>{(pageProps.page - 1) * pageProps.entryLimit + index + 1}</td>
                                    <td>{highlightText(item.user, searchValue)}</td>
                                    <td>{highlightText(item.email || "404 Not Found", searchValue)}</td>
                                    <td>
                                      <Link to={`/eas/licence/${encodeId(item.id)}`}>
                                        {highlightText(item.k_ey, searchValue)}
                                      </Link>
                                    </td>
                                    <td>
                                      <span className={`badge badge-rounded badge-${item.status === "Active" ? "success" : "danger"}`}>
                                        {item.status}
                                      </span>
                                    </td>
                                    <td>{new Date(item?.created).toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' })}</td>
                                    <td><span className={`badge badge-rounded badge-${item?.type === "Normal" ? "secondary" : "info"}`}>{item?.type}</span></td>
                                    <td>
                                      <div className="dropdown custom-dropdown mb-0">
                                        <div className="btn sharp btn-primary tp-btn" data-bs-toggle="dropdown">
                                          <svg width="18px" height="18px" viewBox="0 0 24 24">
                                            <circle fill="#000" cx="12" cy="5" r="2" />
                                            <circle fill="#000" cx="12" cy="12" r="2" />
                                            <circle fill="#000" cx="12" cy="19" r="2" />
                                          </svg>
                                        </div>
                                        <div className="dropdown-menu dropdown-menu-end">
                                          <Link to={`/eas/licence/${encodeId(item.id)}`} className="dropdown-item" href="#">Details</Link>

                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="7" className="text-center py-5">
                                    <div className="d-flex flex-column justify-content-center align-items-center py-5">
                                      <i className="fa fa-folder-open text-muted mb-3" style={{ fontSize: "4rem" }}></i>
                                      <h3 className="text-muted">No Licence Found</h3>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                      </div>

                    </div>

                    <Pagination
                      pageProps={pageProps}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>


            </div>
          </>


        </div>
      </div>

      <div className="modal fade" id="editEAModal" tabIndex="-1" aria-labelledby="editEAModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg ">
          <div className="modal-content rounded-3 shadow">
            <div className="modal-header border-0">
              <h5 className="modal-title fw-semibold" id="exampleModalLabel">Edit Expert Advisor </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="card-body">
              <EditEAForm expert={expert} setExpert={setExpert} />
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="deleteModalCenter">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Delete EA</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal">
              </button>
            </div>
            <div className="modal-body">
              <h6>Are you sure you want to delete this EA?</h6>
              <p>This action will also delete all associated symbols and licences. Additionally, any licences generated for this EA will be subtracted from your profile.</p>
              <div className="form-check mt-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="confirmDeleteCheck"
                  checked={confirmDelete}
                  onChange={(e) => setConfirmDelete(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="confirmDeleteCheck">
                  I understand the consequences of this action.
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-dark light" data-bs-dismiss="modal">Cancel</button>
              <button type="button" className="btn btn-danger" data-bs-dismiss="modal" disabled={!confirmDelete && pageLoading} onClick={handleDeleteEA}>{pageLoading ? <ButtonLoader /> : "Delete"}</button>
            </div>
          </div>
        </div>
      </div>
    </UserPageLayout>
  );
}